export default __webpack_public_path__ + "static/media/Super_Certified_Mentor.6b782b6a.png";